<template>
  <div class="m-card-pay">
    <van-dialog
      v-model="dialogModel"
      show-cancel-button
      :confirmButtonText="$t('confirm.msg_fail_confirm')"
      :cancelButtonText="$t('confirm.msg_fail_cancel')"
      :before-close="onPayment"
    >
      <van-row class="card-pay-dialog">
        <div class="card-dropdown">
          <van-dropdown-menu>
            <van-dropdown-item
              :options="bankCodeList"
              v-model="payInfo.DebtorBankCode"
            />
          </van-dropdown-menu>
        </div>
        <van-field
          type="text"
          placeholder="Debtor Cell Phone"
          class="card-pay-dialog-card"
          v-model="payInfo.DebtorCellPhone"
        />
        <van-col span="13">
          <van-field
            type="text"
            placeholder="DebtorID"
            v-model="payInfo.DebtorID"
          />
        </van-col>
        <van-col span="1"></van-col>
        <van-col span="10">
          <van-field
            type="number"
            placeholder="Token"
            v-model="payInfo.Token"
          />
        </van-col>
      </van-row>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import multicurrencyMixin from "../../../mixins/multicurrency";
export default {
  name: "SaveCardPay",
  mixins: [multicurrencyMixin],
  props: {
    payMode: {},
    payType: {},
    paymentId: {
      type: [String, Number],
      default: ""
    },
    dialogPopup: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  watch: {
    dialogPopup(val) {
      this.dialogModel = val;
      if (val && !this.payMode.includes('BncEnLinea_VPOS')) this.loadBankCodeList();
    }
  },
  computed: {
    ...mapState(["system", "user"]),
    i18n() {
      return this.$t("confirm");
    }
  },
  data() {
    return {
      dialogModel: false,
      isAreaView: false,
      payInfo: {
        show: false,
        Token: "",
        DebtorID: "",
        DebtorBankCode: "0",
        DebtorCellPhone: ""
      },
      bankCodeList: []
    };
  },
  methods: {
    // SaveCardPay 支付
    SaveCardPay(done) {
      const fieldValues = { ...this.payInfo };
      if (!fieldValues.DebtorBankCode) {
        this.$toast(`请选择 DebtorBankCode`);
      } else if (!fieldValues.DebtorCellPhone) {
        this.$toast(`请输入 DebtorCellPhone`);
      } else if (!fieldValues.DebtorID) {
        this.$toast(`请输入 DebtorID`);
      } else if (!fieldValues.Token) {
        this.$toast(`请输入 Token`);
      } else {
        this.payInfo = {
          ...fieldValues,
          Token: "",
          DebtorID: "",
          DebtorBankCode: "",
          DebtorCellPhone: ""
        };
        this.$emit("onPayment", { show: false, ...fieldValues });
        return done();
      }
      return done(false);
    },
    // 确认支付
    onPayment(action, done) {
      if (action === "confirm") {
        this.SaveCardPay(done);
      } else if (action === "cancel") {
        this.$emit("onPayment", { show: false, cancel: true });
        done();
      }
    },
    // 加载BankCode列表
    async loadBankCodeList() {
      this.$loading(true);
      var res = await this.multicurrencyBanks(this.paymentId);
      this.$loading(false);
      if (this.payMode === res.paymentType && res.bankList) {
        var bankCodeList = res.bankList.map(item => {
          return { value: item.Code, text: `${item.Name}(${item.Code})` };
        });
        bankCodeList.unshift({ value: "0", text: `Please select` });
        this.bankCodeList = bankCodeList;
      }
    }
  },
  mounted() {},
  created() {
    if (this.user && this.user.email) {
      this.payInfo.email = this.user.email;
    }
  }
};
</script>

<style lang="less" scoped>
.pay-popup {
  margin: 64px 0 32px;
  padding: 24px 46px;
  &-number {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding-left: 24px;
    border-radius: 16px;
    border: 1px solid #ccc;
    overflow: hidden;
  }
  &-phone {
    font-size: 32px;
  }
}
.card-pay-dialog {
  width: 90%;
  margin: 64px auto 42px;
  .van-cell {
    border: 1px solid #ebedf0;
    border-radius: 12px;
  }
  &-card {
    margin: 28px 0;
  }
}
</style>
<style lang="less">
.card-dropdown {
  position: relative;
  margin: 0 auto;
  .van-dropdown-item--down {
    top: 180px !important;
  }
}
</style>
